import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import HomePage from "./HomePage";
import Processing from "./components/Processing";
import About from "./components/About";
import CatalogDownloadPage from "./components/CatalogDownloadPage";
// 色系頁面
import ColorSeriesPage from "./components/ColorSeriesPage";
import ColorSeriesDetailPage from "./components/ColorSeriesDetailPage";
// 管理面板
import AdminPanel from "./components/AdminPanel";

const App = () => {
  return (
    <Router>
      <div className="bg-background-color min-h-screen">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/processing"
            element={
              <Layout>
                <Processing />
              </Layout>
            }
          />
          <Route path="/admin" element={<AdminPanel />} />
          <Route
            path="/color-series"
            element={
              <Layout>
                <ColorSeriesPage />
              </Layout>
            }
          />
          <Route
            path="/color-series/:id"
            element={
              <Layout>
                <ColorSeriesDetailPage />
              </Layout>
            }
          />
          <Route
            path="/about"
            element={
              <Layout>
                <About />
              </Layout>
            }
          />
          <Route
            path="/catalog-download"
            element={
              <Layout>
                <CatalogDownloadPage />
              </Layout>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
